import { inject, Pipe, PipeTransform } from '@angular/core';
import { DecimalConfigService } from 'app/services/decimal-config.service';

@Pipe({
  name: 'moneda',
  standalone: true
})
export class MonedaPipe implements PipeTransform {
  private configService = inject(DecimalConfigService);

  transform(value: number,  decimales: number = 2): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const decimalPlaces = decimales ?? this.configService.getDecimals();
    // Formatear el número como moneda
    // return `${symbol} ${value.toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    //return value.toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    const parts = value.toFixed(decimalPlaces).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

}
